import React, { useContext } from 'react';
import { testMode } from '../utils/lamba-api';
import BruceModeContext from '../contexts/BruceModeContext';

const Header = () => {
    
    const [bM, setBM] = useContext(BruceModeContext);
    // const onClickHandler = async () => {
    //     return await testMode();
    // }

    return (
        <div id="header-container" className={`${bM.isBruce ? "title-black" : ""}`}>
            <span id="title" className={`${bM.isBruce ? "title-black" : ""}`}>
            Lola's
            </span>
            <div id="seating-title-container">
                <span className="seating-title">Seating 1</span>
                <span className="seating-title">Seating 2</span>
            </div>
            {/* <button onClick={onClickHandler}>
                CLICK ME
            </button> */}
        </div>
    );
};

export default Header;
